import React from "react";
import { useChats } from "..";

export function useChat(id) {
  const chats = useChats();
  return React.useMemo(() => chats.find((chat) => chat.id === id), [chats]);
}
